module.exports = __webpack_public_path__ + "img/textarea-icon.6aa22a9d.svg";